export default "__VITE_ASSET__BbVS_Qno__"